import {useAppSelector} from "../../../redux/hooks";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterFeatureArrangementTypesLogic {
  arrangementTypeIds: number[];
}

export const useFilterFeatureArrangementTypesLogic = (): IFilterFeatureArrangementTypesLogic => {
  const arrangementTypeIds = useAppSelector(mySongsFiltersStore.getArrangementTypeIds);
  return {
    arrangementTypeIds,
  };
}
